import { DataManager } from "../model/DataManager.js";
import { VOVideo } from "../model/DataStructure.js";
import { VideoText } from "./VideoText.js";

export class SidebarToggle {

    public element: HTMLDivElement;

    private _toggle: HTMLElement;
    private _content: HTMLElement;
    private _text: VideoText;

    constructor(private _data: DataManager) {
        this.element = document.createElement("div");
        this.element.className = "sidebar-toggle";
        this.element.innerHTML = `
            <div class="sidebar-toggle-button">
                <i class="sidebar-toggle-button-icon inactive icon-565"></i>
                <i class="sidebar-toggle-button-icon active icon-16"></i>
            </div>
            <div class="sidebar-toggle-content"></div>
        `;

        this._toggle = this.element.querySelector(".sidebar-toggle-button");
        this._content = this.element.querySelector(".sidebar-toggle-content");

        this._text = new VideoText(this._data);
        this._content.appendChild(this._text.element);

        this._toggle.addEventListener("click", () => {
            this.active = !this.active;
        });

        this.active = this._data.config.sidebar_open;

        // this._fullToggle = this.element.querySelector(".video-view-info-sidebar-toggle-button");
        // this.element.querySelector<HTMLDivElement>(".video-view-info-sidebar-toggle").classList.toggle("hidden", !this._data.config.show_fullscreen_control);
        // this._fullToggle.addEventListener("click", () => document.body.classList.remove("fullscreen"));
    }

    public reset():void{
        this.active = this._data.config.sidebar_open;
    }

    public get active(): boolean {
        return this.element.classList.contains("active");
    }

    public set active(value: boolean) {
        this.element.classList.toggle("active", value);
        document.body.classList.toggle("sidebar-active", value);
    }

    public get video(): VOVideo {
        return this._text.video;
    }

    public set video(video: VOVideo) {
        this._text.video = video;
    }
}